import { Component, OnInit } from "@angular/core";
import { CommonService } from "../../../common/common.service";
import { Router, ActivatedRoute } from "@angular/router";
import { HttpClientService } from "../../../common/http-client.service";
import { ToastService } from "../../../common/toast.service";
import { Headers, RequestOptions } from "@angular/http";
declare var swal: any;

@Component({
  selector: "app-admin-activation",
  templateUrl: "./admin-activation.component.html",
  styleUrls: ["./admin-activation.component.css"],
})
export class AdminActivationComponent implements OnInit {
  linkId: string = "";
  adminDetails: any = null;
  loading: boolean = false;
  passwordSetup: boolean = false;

  password: string = "";
  confirmPassword: string = "";

  passwordShow: object = {};
  cpasswordShow: object = {};
  invalidPassword: boolean = false;
  invalidOld: boolean = false;
  showPopup: boolean = false;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  passwordMismatch: boolean = false;
  minLengthError: boolean = false;
  maxLengthError: boolean = false;
  confirmMaxLengthError: boolean = false;
  submitted: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClientService,
    private commonService: CommonService,
    private toast: ToastService
  ) {}

  ngOnInit() {
    this.showPopup = true;
    this.route.queryParams.subscribe((params) => {
      this.linkId = params["linkId"];

      if (this.linkId) {
        this.fetchAdminDetails();
      } else {
        this.toast.error("Invalid activation link. Link ID is missing.");
        setTimeout(() => {
          this.router.navigate(["/auth/login"]);
        }, 2000);
      }
    });
  }

  fetchAdminDetails() {
    this.loading = true;
    const url = `userManagement/admin/LINK_ID/${this.linkId}?isPayload=0`;

    // Follow the exact same auth header pattern as login
    // Create header object with same headers as login request
    let head: any = {};
    head[this.commonService.authToken] = this.commonService.staticToken;
    // Add userId header if available (same pattern as refresh/logout service)
    const userId = this.commonService.getUserId();
    if (userId) {
      head[this.commonService.headerUserId] = userId;
    }
    // jwt() method automatically adds locale: "en" and language: "ENG"
    // These match the headers sent during login

    // Pass header to http.get() - jwt() method will convert it to RequestOptions
    // This is the same pattern used in login.service.ts
    this.http.get(url, null, 6, head as any).subscribe(
      (response) => {
        this.loading = false;
        if (response && response.entityId) {
          this.adminDetails = response;
          this.passwordSetup = true;
        } else {
          this.toast.error("Admin details not found or invalid link.");
          setTimeout(() => {
            this.router.navigate(["/auth/login"]);
          }, 2000);
        }
      },
      (error) => {
        this.loading = false;
        this.toast.error("Failed to fetch admin details. Please try again.");
        console.error("Error fetching admin details:", error);
        setTimeout(() => {
          this.router.navigate(["/auth/login"]);
        }, 2000);
      }
    );
  }

  setupPassword(event: any, valid: boolean) {
    event.preventDefault();

    this.validatePassword();
    this.validateConfirmPassword();

    if (
      !valid ||
      this.minLengthError ||
      this.maxLengthError ||
      this.invalidPassword ||
      this.passwordMismatch ||
      this.confirmMaxLengthError ||
      this.invalidOld
    ) {
      return;
    }

    if (!this.adminDetails || !this.adminDetails.entityId) {
      this.toast.error("Admin details not available.");
      return;
    }

    this.loading = true;

    const trimmedPassword = this.password.trim();
    const requestBody = {
      dfsRequestInfo: {
        entityId: this.adminDetails.entityId,
        password: trimmedPassword,
      },
      dfsCommonServiceRequest: {
        requestId: this.commonService.getRequestId(),
        clientTransactionId: this.commonService.getRequestId(),
      },
    };

    let head: any = {};
    head[this.commonService.authToken] = this.commonService.staticToken;
    const userId = this.commonService.getUserId();
    if (userId) {
      head[this.commonService.headerUserId] = userId;
    }

    this.http.post("login/password", requestBody, 33, head as any).subscribe(
      (response) => {
        this.loading = false;
        swal(
          {
            title: "Success",
            text: "Password created successfully. You can now login with your username and password.",
            type: "success",
            confirmButtonText: "Ok",
          },
          () => {
            this.router.navigate(["/auth/login"]);
          }
        );
      },
      (error) => {
        this.loading = false;
        console.error("Error setting password:", error);
        const errorMessage =
          (error && error.error && error.error.message) ||
          "Failed to set password. Please try again.";
        swal({
          title: "Error",
          text: errorMessage,
          type: "error",
          confirmButtonText: "Ok",
        });
      }
    );
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  validatePassword() {
    this.minLengthError = false;
    this.maxLengthError = false;
    this.invalidPassword = false;

    if (this.password && this.password.length > 0) {
      if (this.password.length < 6) {
        this.minLengthError = true;
      }

      if (this.password.length > 50) {
        this.maxLengthError = true;
      }

      if (this.password.length >= 6 && this.password.length <= 50) {
        var patt = /^(?=.*[0-9])(?=.*[@#$%^&+=]).*$/;
        this.invalidPassword = !patt.test(this.password.trim());
      }
    }

    this.checkPasswordMatch();
  }

  validateConfirmPassword() {
    this.confirmMaxLengthError = false;
    this.invalidOld = false;

    if (this.confirmPassword && this.confirmPassword.length > 0) {
      if (this.confirmPassword.length > 50) {
        this.confirmMaxLengthError = true;
      }

      if (
        this.confirmPassword.length >= 6 &&
        this.confirmPassword.length <= 50
      ) {
        var patt = /^(?=.*[0-9])(?=.*[@#$%^&+=]).*$/;
        this.invalidOld = !patt.test(this.confirmPassword.trim());
      }
    }

    this.checkPasswordMatch();
  }

  checkPasswordMatch() {
    if (
      this.password &&
      this.confirmPassword &&
      this.password.length > 0 &&
      this.confirmPassword.length > 0
    ) {
      this.passwordMismatch = this.password !== this.confirmPassword;
    } else {
      this.passwordMismatch = false;
    }
  }
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/auth/login/admin-activation/admin-activation.component.ts